module.exports = __webpack_public_path__ + "static/media/seeker.d67ada71.svg";